module.exports = __webpack_public_path__ + "img/noPosition.a303082b.png";